function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8082",
  transform: "translate(-463 -399)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 174",
  cx: 35,
  cy: 35,
  r: 35,
  transform: "translate(463 399)",
  fill: "#e8f6f4"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon feather-check-circle",
  fill: "none",
  stroke: "#a1dbd3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6597",
  d: "M515.451 433.413v1.583a17.244 17.244 0 01-12.5 16.495 17.572 17.572 0 01-19.592-7.137 17.023 17.023 0 011.374-20.55 17.617 17.617 0 0120.369-4.538"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6598",
  d: "M515.451 421.227L498 438.455l-5.236-5.161"
})));
const SvgCheckmarkCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 70 70"
}, props), _ref);
export default SvgCheckmarkCircle;